<template>
  <div class="wrapping-box-container">
    <div id="controls" class="controls"></div>

    <LockLoader
      asset="lock-icon.svg"
      text="Iniciando análise..."
    />
  </div>
</template>

<script>
import LockLoader from '@/components/common/LockLoader.vue';
// eslint-disable-next-line import/no-cycle
import { FaceTec } from '@/services/facetec';
import logger from '../../../lib/logger';

export default {
  name: 'onboarding-selfie-faceTec-camera',
  components: { LockLoader },
  async mounted() {
    try {
      const { success } = await FaceTec.openSession();
      if (success) {
        FaceTec.onLivenessCheckPressed();
      }
    } catch (error) {
      logger.error(error);
      this.$router.replace({
        name: 'onboarding-error',
        query: this.$route.query,
      });
    }
  },
};
</script>
